import { http } from '../../config/axios'

export default function getMotorCreditoFormula(): Promise<any[]> {
  return http
    .get('api/motorcreditoformula')
    .then((res) => {
      return res.data as any[]
    })
    .catch((error) => {
      console.error('Erro getMotorCreditoFormula', error)
      throw Error(error.response.data)
    })
}
